module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("DOROTHY")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As it was Saturday, many visitors came to the villa, Giuseppe receiving them at the open door, and waving them across the court or up the stone stairway, according to their apparent inclination, murmuring as he did so: “To the garden; the Signora North!” “To the salon; the Signora Tracy!” with his most inviting smiles. Dorothy probably was with Mrs. North in the garden. And everybody knew that the tea and the comfortable chairs were up-stairs. The company therefore divided itself, the young people as far as possible, then men who like to appear young, and the mothers who have heavier cares than the effects of open-air light on a middle-aged complexion, crossing the paved quadrangle to the north hall, while the old ladies and the ladies (not so old) who detest gardens ascended the stairs, accompanied by, first, the contented husbands; second, the well-trained husbands; third, other men, bond or free, who cherish no fondness for damp belvederes, for grassy mounds, or for poising themselves on a parapet which has a yawing abyss below.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Giuseppe was the gardener; he became a footman once a week, that is, on Saturday afternoons, when the American ladies of the Villa Dorio received those of their friends who cared to come to their hill-top above the Roman Gate of Florence—a hill-top bearing the appropriate name of Bellosguardo. For fair indeed is the outlook from that supremely blessed plateau, whether towards the north, south, east, or west, with perhaps an especial loveliness towards the west, where the Arno winds down to the sea. Enchanting as is this Occidental landscape, Mrs. Tracy had ended by escaping from it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When each new person begins: ‘Oh, what lovely shadows!’ ‘Oh, the Carrara Mountains!’ we cannot look at each other, Laura and I,” she explained; “it’s like the two Roman what-do-you-call-ems—augurs. I’m incapable of saying another word about the Carrara Mountains, Laura; and so, after this, I shall leave them to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This was the cause of Giuseppe’s indicating the drawing-room, and not the garden, as Mrs. Tracy’s domain.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was not difficult for Giuseppe to turn himself into a footman; Raffaello, the butler (or cameriere), could have turned himself into a coachman, a cook, a laundress, a gardener, or even a parlor-maid, if occasion had so required; for Italian servants can do anything. And if Mrs. Sebright sighed, “Ah, but so badly!” (which was partly true from the English point of view) the Americans at least could respond, “Yes, but so easily!” In truth, it was not precisely in accordance with the English standard to be welcomed by smiles of personal recognition from the footman at the door, nor to have the tea offered by the butler with an urgent hospitality which was almost tender. But Italy is not England; radiant smiles from the servants accord perhaps with radiant sunshine from the sky, both things being unknown at home. As for the American standard, it does not exist, save as a vacillating pennon.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Villa Dorio is a large, ancient structure of pale yellow hue; as is often the case in Tuscany, its façade rises directly from the roadway, so that any one can drive to the door, and knock by simply leaning from the carriage. But privacy is preserved all the same by the massive thickness of the stone walls, by the stern iron cages over the lofty lower windows, and by an entrance portal which resembles the gateway of a fortress. The villa, which, in the shape of a parallelogram, extends round an open court within, is large enough for five or six families; for in the old days, according to the patriarchal Italian custom, the married sons of the house, with their wives and children, were all gathered under its roof. In these later years its tenants have been foreigners, for the most part people of English and American birth—members of that band of pilgrims from the land of fog and the land of haste, who, having once fallen under the spell of Italy, the sorcery of that loveliest of countries, return thither again and yet again, sometimes unconscious of their thraldom, sometimes calling it staying for the education of the children, but seldom pronouncing the frank word “living.” Americans who have stayed in this way for twenty years or more are heard remarking, in solemn tones, “In case I die over here, I am to be taken home to my own country for burial; nothing less could content me.” This post-mortem patriotism probably soothes the conscience.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Upon the Saturday already mentioned the Villa Dorio had but one tenant; for Mrs. Tracy had taken the entire place for a year—the year 1881. She could not occupy it all, even with the assistance of Mrs. North and Dorothy, for there were fifty rooms, besides five kitchens, a chapel, and an orange-house; she had selected, therefore, the range of apartments up-stairs which looked towards the south and west, and the long, frescoed, echoing spaces that remained were left to the ghosts. For there was a ghost, who clanked chains. The spectre of Belmonte, another villa near by, was more interesting; he was a monk in a brown gown, who glided at midnight up the great stairway without a sound, on his way to the tower. The American ladies had chosen for their use the northwestern garden. For the Villa Dorio has more than one garden; and it has also vineyards, olive groves, and the fields of the podere, or farm, in the valley below, with their two fountains, and the little chapel of the Holy Well. The northwestern garden is an enchanting spot. It is not large, and that adds to the charm, for its secluded nearness, so purely personal to the occupier, yet overhangs, or seems to, a full half of Tuscany; from the parapet the vast landscape below rolls towards the sunset as wide and far-stretching as the hidden shelf, one’s standing-point, is private and small. When one ceases to look at the view—if one ever does cease—one perceives that the nook has no formal flower-beds; grass, dotted with the pink daisies of Italy, stretches from the house walls to the edge; here and there are rose-bushes, pomegranates, oleanders, and laurel, but all are half wild. The encircling parapet is breast-high; but, by leaning over, one sees that on the outside the ancient stones go plunging down, in course after course, to a second level far below, the parapet being in reality the top of a massive retaining-wall. At the corner where this rampart turns northward is perched a little belvedere, or arbor, with vines clambering over it. It was upon this parapet, with its dizzy outer descent, that the younger visitors were accustomed to perch themselves when they came to Villa Dorio. And Dorothy herself generally led them in the dangerous experiment. But one could never think of Dorothy as falling; her supple figure conveyed the idea that she could fly—almost—so lightly was it poised upon her little feet; in any case, one felt sure that even if she should take the fancy to throw herself off, she would float to the lower slope as lightly as thistle-down. The case was different regarding the Misses Sebright; they, too, were handsome girls, but they would certainly go down like rocks. And as for Rose Hatherbury, attenuated though she was, there would be, one felt certain, no floating; Rose would cut the air like a needle in her swift descent. Rose was thin (her aunts, the Misses Wood, called it slender); she was a tall girl of twenty-five, who ought to have been beautiful, for her features were well cut and her blue eyes lustrous, while her complexion was delicately fair. Yet somehow all this was without charm. People who liked her said that the charm would come. The Misses Wood, however, spent no time in anticipation; to them the charm was already there; they had always believed that their niece was without a fault. These ladies had come to Florence twenty years before from Providence, Rhode Island; and they had remained, as they said, “for art” (they copied as amateurs in the Uffizi Gallery). Of late they had begun to ask themselves whether art would be enough for Rose.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At five o’clock on this April afternoon the three Misses Sebright, Rose, Owen Charrington—a pink-cheeked young Englishman, long and strong—Wadsworth Brunetti, and Dorothy were all perched upon the parapet, while Miss Maria Wood hovered near, pretending to look for daisies, but in reality ready to catch Rose by the ankles in case she should lose her balance. Miss Jane Wood was sitting with Mrs. North in the aguish belvedere. With remarkable unanimity, the group of men near by had declared that, in order to see the view, one must stand.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Your garden is like an opera-box, Mrs. North,” said Stephen Lefevre; “you sit here at your ease, and see the whole play of morning, noon, and night sweeping over Tuscany.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A view like this is such a humanizer!” remarked Julian Grimston, thoughtfully. “One might indeed call it a hauberk.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To this mysterious comparison Miss Jane Wood responded, cheerfully, “Quite so.” She did not ask for explanations (Julian’s explanations were serious affairs); she spoke merely on general principles; for the Misses Wood considered Julian “such an earnest creature!” Julian, a wizened little American of uncertain age, was protected by a handsome mother, who possessed a firm eye and a man-like mouth; this lady had almost secured for her son an Italian countess of large circumference and ancient name. Julian so far held back; but he would yet go forward.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Its most admirable quality, to my mind, is that it’s here,” Mr. Illingsworth remarked, after Julian’s “hauberk.” “Generally, when there is a noble view, one has to go noble miles to see it; one has to be out all day, and eat hard-boiled eggs on the grass. You can’t think how I loathe hard-boiled eggs! Or else one has to sleep in some impossible place, and be routed out at dawn. Can any one admire anything at dawn?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "src": "image/1.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("THE VILLA DORIO")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There isn’t much dawn in this,” answered Daniel Ashcraft. “Up to noon the view’s all mist, and at noon everything looks too near. It doesn’t amount to much before four o’clock, and only shows out all its points as the sun goes down.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And have you discovered that, Mr. Ashcraft, on your third day in Florence?” demanded Illingsworth, with admiration. “But it’s only another instance of the quick intelligence of your wonderful nation. Now I have lived in the town for twenty-five years, and have never noticed that this Carrara view was an afternoon affair. Yet so it is—so it is!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Daniel Ashcraft surveyed the Englishman for a moment. “Oh yes—our quick intelligence. It makes us feel as though we were being exhibited. Sixpence a head.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("More visitors appeared; by half-past five there were forty persons in the garden. Mrs. North received them all very graciously without stirring from her belvedere. Dorothy, however, was everywhere, like a sprite; and wherever Dorothy was Owen Charrington soon appeared. As for Wadsworth Brunetti, his method was more direct—he never left her side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They are both her shadows,” said Beatrice Sebright, in an undertone, to Rose Hatherbury, as they sat perched side by side on the parapet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She is welcome to them,” answered Rose. “A burly creature like Owen; and that Waddy!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Waddy?” repeated Beatrice, inquiringly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A simpleton,” pronounced Rose, with decision.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Honest Beatrice surveyed her companion with wonder, into which crept something almost like envy; if she, Beatrice, could only think that Owen was burly; and if it were but possible, by trying hard, to regard Wadsworth Brunetti as a simpleton, how much easier life would be! As it was, she was convinced that Owen was not burly at all, but only athletic. And as to Waddy Brunetti, he was simply Raphael’s young St. John in the Tribune of the Uffizi—the St. John at twenty-two, and in the attire of to-day. Wadsworth Brunetti’s American mother had done her best to make an American of her only child; Waddy could speak the language of New York (when he chose); but in all other respects—his ideas, his manner, his intonations, his hair arranged after the fashion of King Humbert’s, his shoes, his collar and gloves—he was as much a Florentine as his father. The Misses Sebright were not mistaken in their estimation of his appearance; he was exceedingly handsome. And the adverb is used advisedly, for his beauty exceeded that degree of good looks which is, on the whole, the best for every-day use; one hardly knew what to do with young Brunetti in any company, for he was always so much handsomer than the other guests, whether women or men.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Isn’t it enough that he allows himself to be called Waddy?” Rose had demanded in the same contemptuous undertone. “Waddy—wadding. What a name!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But Madame Brunetti tells us that Wadsworth is one of the very best of American names?” objected Beatrice, timidly, still clinging to her idol.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She’s mad; there are no best American names—unless one cares for those attached to the Declaration of Independence. The thing is, the best American men; and do you call Waddy that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Beatrice did. But she dared not confess it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Dorothy, I have forgotten my shawl,” said Mrs. North, as Dorothy happened to pass the arbor.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll go for it,” said Charrington.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is it in the drawing-room?” inquired Julian Grimston. “A blue and white, with knotted fringe?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy, meanwhile, was crossing the grass towards the house; Lefevre followed her; Waddy accompanied her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nobody can get it but Dorothy—thanks; it is in my own room,” said Mrs. North.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Charrington and Julian paused; Lefevre came back. Mrs. North said to Lefevre, “Praise my prudence in sending for a shawl.” Then she added, laughing, “You dare not; prudence is so elderly!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She could afford to make a joke of age; tall, thin, with abundant drab-colored hair and a smooth complexion, she did not look more than thirty-five, though she was in reality ten years older. She was a widow; her husband, Richard North, had been an officer in the American navy, and Dorothy was her step-daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy and Waddy had gone on, and were now entering the north hall. This vacant stone-floored apartment, as large as a ball-room, with a vaulted ceiling twenty-four feet high, was the home of an energetic echo; spoken words were repeated with unexpected force, in accents musical but mocking. It was one thing for Waddy to murmur, “Give me but a grain of hope, only a grain,” in pleading tones, and another to have the murmur come back like an opera chorus. Dorothy paused demurely, as if waiting for the conclusion of the sentence. But her picturesque suitor, still hearing his own roaring “grrrrain,” bit his lips and tried to hasten their steps towards the other door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, I thought you had something to say!” remarked Dorothy, innocently, when they reached the arcade within. “But you never have, have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And with this she crossed the quadrangle to welcome four new guests who were about to ascend the stairway in answer to Giuseppe’s “The salon! Signora Tracy!” Waddy went up the stairs also. But he could not hope to follow to the remote region of Mrs. North’s chamber, so he accompanied the new guests through the anterooms to the drawing-room at the end of the suite, where Mrs. Tracy, the second hostess, received them all with cordial greetings. Mrs. Tracy’s years were fifty. She hoped that she was fine-looking, that epithet being sometimes applied to tall persons who hold up their heads, even if they are stout; even, too, if their noses are not long enough for classical requirements. She certainly held up her head. And she was always very well dressed; so well that it was too well. After saying a few words to Waddy, she passed him on to Miss Philipps, who stood near her. Felicia Philipps despised the beautiful youth. But she was willing to look at him for a few minutes as one looks at—a statue? Oh no, that would never have been Felicia’s word; at wax-works, that was more like it; Felicia had a sharp tongue. She now chaffed the wax-works a little, pretending to compliment its voice; for Waddy could sing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As I sing too, Mr. Brunetti, we’re companions in soul,” she said. “But, unfortunately, when I sing, my soul does not come to my eyes, as yours does.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The comfort of Waddy is that you can make mince-meat of him to his face, when you feel savage, and he never knows it,” she had once remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was, however, another side to this: Waddy did not know, very possibly, but the reason was that he never paid sufficient heed to Miss Felicia Philipps to comprehend what she might be saying, good or bad; to his mind, Felicia was only “that old maid.” Mrs. Tracy, for the moment not called upon to extend her tightly gloved hand to either arriving or departing guests, expanded her fingers furtively, in order to rest them, and glanced about her. Her rooms were full; there was a steady murmur of conversation; the air was filled with the perfume of flowers and the aroma of tea, and there were suggestions also of the petits fours, the bouchées aux confitures, and the delicate Italian sandwiches which Raffaello was carrying about with the air of an affectionate younger brother. Waddy, who cherished a vision of Dorothy coming to get a cup of tea for her mother (Waddy had noticed upon other Saturdays that “my shawl” meant tea), detached himself as soon as he could from Felicia, and made his way towards the tea-table in the opposite corner. Here Nora Sebright was standing behind a resplendent samovar. Mrs. Tracy had purchased this decorative steam-engine in Russia; but she had not dared to use it until Nora, seeing it at the villa one day, had offered to teach her its mysteries. Mrs. Tracy never learned them; but Nora came up every Saturday, and made the tea in her neat, exact way. She was number one of the Misses Sebright. Six sisters followed her. But this need not have meant that Nora was very mature, because hardly more than a year separated the majority of the Sebright girls (one could say the majority of them or the minority, there were so many). As it happened, however, Nora was twenty-nine, although Peggy, the next one, was barely twenty-five; for the six younger sisters were between that age and sixteen. These younger girls were tall, blooming, and handsome. Nora was small, insignificant, and pale; but her eyes were charming, if one took the trouble to look at them, and there was something pretty in her soft, dark hair, put back plainly and primly behind her ears, with a smooth parting in front; one felt sure that she did not arrange it in that way from a pious contentment with her own appearance, but rather from some shy little ideal of her own, which she would never tell.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you think they have all had tea?” she was saying anxiously as Waddy came up. She addressed a gentleman by her side who had evidently been acting as her assistant.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I think so,” he answered, looking about the room with almost as much solicitude as her own.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her face cleared; she laughed. “It’s so kind of you! You have carried cups all the afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I only hope I haven’t broken any,” responded her companion, still with a trace of responsibility in his tone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It is terribly dangerous, with so many people pushing against one. How you can do it so cleverly, I can’t think. But indeed, Mr. Mackenzie, I do not believe you could let anything drop,” Nora went on, paying him her highest compliment. “This is the fourth Saturday you have given to these teacups; I am afraid it has been tiresome. Raffaello ought to do it all; but Italian servants—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They are not like yours in England; I can understand that. But Raffaello, now—Raffaello has seemed to me rather a good fellow,” said Mackenzie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At this moment Dorothy, carrying a shawl, appeared at the door; she made her way to the table. “May I have some tea, Miss Sebright, please, for mamma?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I will carry it for you,” said Waddy, eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Won’t you take some tea yourself, Miss Dorothy, before you go back to the garden?” suggested Mackenzie, in his deferential tones.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I? Do you think I take tea? And how can you like it, Mr. Mackenzie? You’re not an Englishman.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Waddy thanked fate that his mother had entered human existence in New York. Charrington, who was now near the table also, only laughed good-naturedly. On the whole he was of the opinion that Dorothy liked him. Her ideas about tea, or about other English customs, were not important; he could alter them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am afraid I must acknowledge that I do like it,” Mackenzie had answered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you take it in the morning—for breakfast?” inquired Dorothy, with the air of a judge.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mackenzie confessed that he did.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Then you are lost. Oh, coffee, lovely coffee of home!” Dorothy went on. “Coffee that fills the house at breakfast-time with its delicious fragrance. Not black, as the Italians make it. Not drowned in boiled milk, as the French drink it. As for the English beverage— But ours, the American—brown, strong, and with real cream! I wish I had a cup of it now—three cups—and six buckwheat cakes with maple syrup!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The contrast between this evoked repast and the girl herself was so comical that the Americans who heard her broke into a laugh. Dorothy was very slight; there was something ethereal in her appearance, although the color in her cheeks, the brilliancy of her hazel eyes, and the bright hue of her chestnut hair indicated a vivid vitality. As a whole, she was charmingly pretty. The Americans who had laughed were but two—Mackenzie himself and Stephen Lefevre, who had now joined the group. Lefevre wished that his adorable little countrywoman would not say “lovely coffee.” But Lefevre was, no doubt, a purist.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Felicia Philipps now came to the table with out-stretched hands. “Poor Nora, I have only just observed how tired you are! You must have one of your fearful headaches?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh dear, no,” answered Nora, surprised. “I haven’t a headache in the least.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Fancy! But you are overtired without knowing it; you must be, or you would not look so pale. I am sure Mr. Mackenzie sees it. Don’t you think, Mr. Mackenzie, that Miss Sebright has been here quite long enough? I’m so anxious to relieve her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s very good of you, I’m sure,” replied Mackenzie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And then Felicia, pulling off her gloves, came round behind the table and took possession of the place with an amiability and a rearrangement of the cups that defied opposition.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am afraid this tea will be cold,” Waddy meanwhile had suggested to Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, do take it down to mamma, Mr. Brunetti. And take this shawl too, won’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aren’t you coming?” said Waddy, in a discomfited voice, as, shawl in one hand and teacup in the other, he stood waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“In five minutes; I have taken a fancy for spending just five minutes in that big yellow chair.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That is wise; I’m very pleased to hear you say it,” remarked Nora, who, though dispossessed, still lingered near. “We come up here, stay awhile, and then go away; but you are kept on your feet for three or four hours at a time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You don’t go away, do you, Nora?” said Felicia. “You are so kind. I dare say you have been here since noon?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The samovar—” began Nora.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Dear samovar!” commented Felicia, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And then Nora, at last understanding the sarcasm of the tone, left the table and crossed the room, her cheeks no longer colorless. Alan Mackenzie, who had heard this little dialogue, thought that the two ladies had been very kind to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy, on her way back from the anteroom, whither she had gone to escort Julian Grimston’s mother, who was taking leave, now stopped at the tea-table. She drew Felicia aside. “Stay and dine with us, won’t you? We are always tired on Saturday evenings, and it will be delightful to hear you sing. The carriage shall take you home.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re awfully good,” Felicia answered. “But don’t trouble to send out the carriage. Ask Mr. Mackenzie too. He will be enchanted to stay, and then we can go down together on foot, and nobody need be bothered.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You don’t mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“At my age!” answered Felicia, smiling. Felicia’s smile always had a slightly hungry look.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We shouldn’t think of it. But then we’re Americans,” responded Mrs. Tracy. “Over here no woman seems to be safely old.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is that why so many of you come over?” demanded Felicia, who at heart detested all American women, especially those who, like the tenants of Villa Dorio, had plenty of money at their disposal. Then curbing her tongue, she added, “What you say is true of wives and widows. But I assure you that old maids are shelved over here as soon and as completely as they are with you in Oregon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“In Oregon!” repeated Mrs. Tracy. “You English are too extraordinary.” And she went away, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("During this conversation Dorothy was leaning back in the gold-colored easy-chair; Charrington and Stephen Lefevre were standing beside her, and presently Julian Grimston joined the group, rubbing his dry little hands together gleefully, and murmuring to himself something that sounded like “Aha! aha!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is it the pure joy of living, Mr. Grimston?” Dorothy inquired. For this was said to have been Julian’s answer when an acquaintance, upon passing him in the street one day and overhearing him ahaing, had asked what it meant.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At this moment Waddy came from the anteroom. “And mamma’s tea?” Dorothy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Raffaello was just going down; I gave it to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, thanks. I’m thinking how little mamma will like that.” And Dorothy played thoughtfully a soundless tune with her right hand upon the arm of the easy-chair.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Waddy pursed up his lips in an inaudible whistle. Then with swift step he left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Five minutes later he was back again. “It’s all right. I caught up with him,” he said, briefly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now mark that,” began Charrington. “This impostor gave those things to Mrs. North, I’ll warrant, with rolling eyes that seemed to say that even to have touched them had been a huge joy.” Waddy did not defend himself. “I wouldn’t be a cherub, as you are, even if I could,” went on Charrington. “You belong to Christmas-cards—your chin on your clasped hands. What is a cherub out of business—a cherub going about clothed, and with an umbrella? It’s ghastly.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy to Miss Jane Wood: “How do you do, Miss Wood?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To Miss Maria: “How do you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Behind the Misses Wood came Rose Hatherbury and three of the Misses Sebright, who were tired of sitting on the wall. Felicia, very busy, sent tea to them all, Mackenzie carrying the cups. Raffaello presented himself at the table to assist. Felicia did not know much Italian, but she did know her own mind, and she wished for no second assistant; she therefore said to Raffaello, in an undertone, but with decision, “Andate via!” Raffaello, astounded by this unexpected “Clear out!” gazed at her for a moment with wild eyes, and then escaped from the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The tea was not good—so the Misses Wood thought as they tried to sip it; Nora Sebright, who was now walking with quick steps through the Via Romana on her way home, would have been distressed to see how bad it was.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I wonder if there is any one in the garden now?” said Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There are fifty-seven persons,” answered Rose, who had seated herself on a sofa near. “I know, because I counted them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Then I must go down,” said Dorothy, rising.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She nodded to Rose and to the others and left the room, Waddy following as usual. Two minutes later, Charrington, Julian Grimston, and Stephen Lefevre had also disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Miss Jane Wood (having given up the tea) now began, graciously, “Did you get your ride this morning, Mr. Charrington?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aunt Jane, Mr. Charrington is not here now,” said Rose, in her distinct tones.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh,” said Miss Jane, bewildered, and fumbling quickly for her eye-glasses, which she had removed when she took her teacup. “He was here a moment ago; I saw him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What wonderful elocutionary powers Miss Hatherbury has!” said Felicia, in an aside, to Mackenzie. “I really think she could be heard in the largest hall.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Upon my word, now that you mention it, I believe she could,” answered Mackenzie, admiringly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rose divined that she was the subject of Felicia’s aside. She said to her aunt, in an interested tone, “How well one sees the Belmonte tower from here!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Miss Jane came to look, and then (in order that she should see to advantage) her niece pulled the cord and rolled the window-shade up to the top, letting in a broad shaft of sunset light, which fell directly across the tea-table and the persons in attendance there. Rose took this moment to carry her aunt’s cup back to the table; and, having put it down, she remained standing by Felicia’s side while she began, composedly, a conversation with Alan Mackenzie. Mackenzie responded: his head immediately assumed the little bend which with him signified devoted listening; he stood, meanwhile, exactly where Rose had intended that he should stand—namely, in front of the two ladies, facing them. Felicia, even in her youth, had had no beauty; now all the faults of her sharp features were pitilessly magnified by the same clear light which brought out the fine-grained purity of Rose’s complexion and turned her golden hair into glittering glory. Felicia was too intelligent to cherish illusions about her appearance; she quivered under the radiance in which the golden motes danced; she too had color now, but it was an ugly vermilion in spots and streaks. She glanced at Mackenzie; he was listening to Rose; now he was offering one of his civil little questions—those attentive, never-failing small interrogatories for which he was celebrated.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I should like to strangle him!” thought the older woman, bitterly. “I believe he would keep up those everlasting little questions on his death-bed. In reality, he doesn’t care the turn of his finger for that screaming popinjay. Yet he stands there and listens to her, and will do it unflinchingly as long as she talks, if it’s all night.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The popinjay at this moment turned, and fired back at Felicia her own gun. “You are tired, Miss Philipps. Doesn’t she look tired, Mr. Mackenzie?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mackenzie turned obediently; he inspected Felicia’s flushed face. “Yes—ah, really, I am afraid you are tired,” he said, kindly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Felicia, unable to bear his gaze, seized her gloves and fled.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But the popinjay could not sing, and had no invitation to stay. Alan Mackenzie loved music. As he never spoke of the love, but few persons had discovered it; Felicia was one of the few.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was nearly eleven o’clock before the song began. They had gone out, after dinner, to the small stone terrace that opened from the drawing-room, in order to look at the valley by the light of the moon. “For we really like our view when we don’t have to talk about it,” Mrs. Tracy explained. After a while, “Come, Felicia,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Felicia went within and opened the piano; Mrs. Tracy, following, sank into the easiest chair; Mrs. North placed herself in the doorway, with her face towards the moonlight. Dorothy remained outside, using the hammock as a swing, pushing herself to and fro slowly by a touch on the parapet now and then. On the other side of the terrace, in a garden-chair, sat the second guest.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Felicia’s voice was a contralto which had not a range of many notes, but each one of the notes was perfect. Her singing was for a room only; it was intimate, personal; perhaps too personal sometimes. The words were, for her, a part of it as much as the melody.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Through the long days and years")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What till my loved one be,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Parted from me.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Through the long days and years?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The music upon which these words were borne was indescribably sweet. Dorothy had stopped swinging. But it was the melody that held her vaguely given attention; she paid no heed to the spoken syllables.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Never on earth again")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Shall I before her stand,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Touch lip or hand,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Never on earth again,”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("sang the voice, the strains floating out to the moonlight in a passion of sorrow. Dorothy was now looking at the tower of Belmonte, near by. “I wish our villa had a tower,” was the thought in her mind. As her gaze turned, she saw that Mackenzie’s eyes were resting upon her, and she smiled back at him, making a mute little gesture of applause.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But while my darling lives,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Peaceful I journey on,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Not quite alone,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Not while my darling lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And now the music rose to that last courage, that acceptance of grief as the daily portion of one’s life, which is the highest pathos. Then there was a silence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy made her little motion of applause again, save that this time the applause was audible; the words on her lips, ready to utter, were, “How pretty that is!” Perhaps Mackenzie divined what these words would be, for, with a quick movement, he rose and went to the end of the terrace, where he stood with his back towards her, looking down the valley. But Dorothy had accomplished her duty; she was perfectly willing to be silent; she sank lazily back in the hammock again, and resumed her swinging.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mr. Mackenzie, wasn’t that exquisite?” said Mrs. Tracy’s voice within.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mackenzie, thus summoned, crossed the terrace and re-entered the drawing-room. Felicia kept her seat at the piano; as Mrs. Tracy was standing behind her, and as Mrs. North’s head was turned away, she was freed for the moment from feminine observation, and she therefore gave herself the luxury of letting all the pathos and passion with which she had sung remain unsubdued in her eyes, which, met his as he came up.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Lovely, wasn’t it? But so sad,” continued Mrs. Tracy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes,” Mackenzie answered; “it is rather sad.” Then, “What song is it, Miss Philipps?” he inquired. “I do not remember having heard it before.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“‘Through the long days,’“ answered Felicia, who was now looking at the piano keys.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah! And the composer?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Francis Boott.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah! Francis Boott, yes. And the words?” His head had now its attentive little bend.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They are by John Hay.” To herself she added: “You shall stop your little questions; you shall say something different!” And again she looked up at him, her eyes strangely lustrous.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And then at last he did say, “May I take the music home with me? You shall have it again to-morrow. It is a very beautiful song.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Felicia rolled up the sheet and gave it to him, her hand slightly rigid as she did so from repressed emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At midnight the two guests took leave, Mrs. Tracy accompanying them down to the entrance portal. The irregular open space, or piazza, before the house had a weird appearance; the roadway looked like beaten silver; the short grass had the hue and gleam of new tin; the atmosphere all about was as visibly white as it is visibly black on a dark night.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "src": "image/2.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“AND AGAIN SHE LOOKED UP AT HIM”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s the moment exactly for our ghost to come out and clank his chains,” said the lady of the house. “This intensely white moonlight is positively creepy; it is made for hobgoblins and sheeted spectres; the Belmonte monk must certainly be dancing on the top of his tower.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“On Thursday, January 8"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("th")]), _vm._v(", at the English church, Florence, by the Reverend J. Chaloner-Bouverie, Alan Mackenzie, to Dorothy, daughter of the late Captain Richard North, United States Navy.”—Galignani’s Messenger of January 10, 1882.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("III.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was St. Mark’s eve again, April 24"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("th")]), _vm._v(", and again there were many visitors at Bellosguardo. Upon this occasion they were assembled at Belmonte, the villa with the old battlemented tower, where Mr. and Mrs. Alan Mackenzie were receiving their Florentine friends for the first time since their marriage; they had been travelling in Sicily and southern Italy through the winter months.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We shall be going home in 1883, I suppose,” Mackenzie had said to the ladies of Villa Dorio; “I shall be obliged to go then; or at least it would be better to go. In the meanwhile, as Dorothy appears to be rather fond of Bellosguardo—don’t you think so?—I have had the idea of taking Belmonte for a time. That is, if you yourselves intend to continue here?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, we shall continue, we shall continue,” Mrs. Tracy had answered, laughing. “For detached American ladies, who haven’t yet come to calling themselves old—for the cultivated superfluous and the intelligent remainders—there is nothing like Europe!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The flat highways down in the Arno Valley, west of Bellosguardo, are deep in dust even as early as April; the villages, consisting for the most part of a shallow line of houses on each side of the road, almost join hands, so that it is not the dust alone that afflicts the pedestrian, but children, dogs, the rinds of fruit and vegetables—all the far-reaching untidiness of a Southern race that lives in the street. The black-eyed women sit in chairs at the edge of the dry gutter, plaiting straw; up to middle-age they are all handsome, with thick hair and soft, dark eyes. On this April afternoon they laughed (waiting with Italian politeness until she had passed) as an Englishwoman trudged by them on her way back to Florence. Her plain dress was short, revealing long shoes white with dust; her unbeautiful face was mottled by the heat; she looked tired enough to lie down and die. But to the straw-plaiting matrons she was simply ridiculous, or else mad; for how otherwise should a foreigner be toiling along their plebeian highway on foot, when she could so easily have a carriage? Felicia was finishing her daily walk of miles—a walk without an object save to tire herself. As she passed the olive-crowned heights of Bellosguardo rising on the right, she lifted her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He is there, seeing everybody. All the same people who were there a year ago to-day. And what are they thinking—perhaps saying? ‘See this dull, middle-aged man, with that flighty little creature for a wife! She cares nothing for him; she turns him round her finger, and always will.’ O fool! fool too noble to see or to doubt; simple, generous nature, never asserting itself, always repressed, that I understood, while all these other people, that girl at the head of them, only laughed at it!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She hastened on, passed through the city gate, and made her way down the dirty, evil-smelling Borgo San Frediano to San Spirito beyond, where, high up in an old palace, she had a small apartment crowded with artistic trumpery. After climbing the long stairs, and letting herself in with a latch-key, she entered her minute drawing-room, and sank into a chair, her feet, in their dusty shoes, like two blocks of wood on the matting before her. And the plates and the plaques and the pots, the bits of silk and tapestry and embroidery, the old sketches and old busts and old shrines that adorned the walls, looked down upon her with their usual heterogeneous glimmer. This time the glimmer seemed personally sarcastic, seemed inhuman.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While she sat there, the people at Belmonte were beginning to take leave. Rose was to remain (with Miss Jane Wood). As Waddy Brunetti was to remain also, the Misses Sebright looked at Rose with envy. Six of the sisters were now united in a single admiration. For Owen Charrington had gone to Australia before Christmas—it was about the time that Dorothy’s engagement had been announced—and he had not returned; admiration could not stretch to the antipodes. Waddy, too, had been absent through January, February, and March; but he was now at home again, so there was some use in going once more to teas and receptions.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How lovely Mrs. Mackenzie is looking!” said Miss Maria Wood on the way down to Florence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She had accepted a seat in Mrs. Grimston’s carriage, and it was that lady who answered her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes—fairly; it’s her youth more than anything else. Strictly speaking, there are but two kinds of beauty—dimpled youth like that, and the noble outline and bearing that come from distinguished birth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This was a double shot. For Rose certainly had no dimples, and the birth of distinction pointed of course to the widowed countess. But Julian, who sat facing his mother, had no longer any courage to resist; his poor little eyes, like those of a sick monkey, had shed their two slow tears on Christmas eve, when, at last allowed to retreat to his own (cold) room, he had accepted drearily the tidings of Dorothy’s engagement, and had given up his struggle against fate.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mr. Illingsworth walked down the hill with Mrs. Sebright, her girls following at a little distance, two and two. “Don’t I miss one of your charming daughters?” he said, gallantly, as, happening to look back at the turn of a zigzag, he caught sight of the procession coming round the higher bend.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Dear me! I wish he might miss three or four!” thought the mother. But this was nothing worse on her part than a natural desire to translate three or four of them to richer atmospheres—a Yorkshire country-house, for instance, or a good vicarage; even army life in India would do. Meanwhile she was replying, “Yes—Nora; Nora has been at St. Martin’s Orphan House, out in the country, since Christmas. She is greatly interested in the work there; so much so that I have consented to let her remain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nora’s secret only one person had discovered, and this one was the benevolent stranger, Charlotte Tracy, who had happened to see the expression in the girl’s eyes for one instant, when the news of Alan Mackenzie’s engagement had come upon her suddenly, and taken her (as it took all Florence) by surprise. The American lady, instantly comprehending, had (while her own face showed nothing) screened Nora skilfully from observation for several minutes. And ever since she had kept her knowledge hidden away very closely in a shaded corner of her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A true Sister of Charity,” Mr. Illingsworth had responded to the mother’s reply about the orphan house. But as he said this he was thinking, “And if I had married, as I came so near doing, I, too, might have had at my heels this moment—great heavens!—just such another red-cheeked, affectionate train!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That evening the ladies who had dined at Belmonte were taking their coffee in the garden; there was no moon, but the splendid stars gave a light of their own as they spangled the dark-blue sky. From the open door of the boudoir at this end of the house, the light, streaming forth, fell upon Dorothy as she sat talking to Rose. After a while the gentlemen joined the ladies; and then Waddy talked to Rose. But while he talked, his eyes followed the hostess, who was now strolling up and down the honeysuckle path with one of her guests. Some one asked Waddy to sing. Nothing loath, he went within, brought out Dorothy’s guitar, and sang one of Tosti’s serenades. The song and his voice, a melodious tenor, accorded so perfectly with the old Italian garden that there was much applause. And then Waddy, having moved his chair into the shadow of the trees, sent forth after a while from the darkness, unasked, a second song, and this time the words were English:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Through the long days, the long days and the years,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What will my loved one be,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Parted from me, parted from me,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Through the long days and years?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The lady who had been strolling with Dorothy had stopped to speak to some one, and for the moment the young wife, who had reached the end of the honeysuckle path, was alone. Mackenzie came up quietly and stood beside her as the song went on. When it had ended, she looked up at him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you like it so much?” she asked, in surprise, as she saw, in the starlight, the expression of his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s because I have so much more than I ever dreamed of having, Dorothy,” he answered, in a low tone, just touching her hair in the shadow. “A year ago—do you remember? That same song, on the terrace? It expressed what I felt; for then I had no hope. But now—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Here a voice from the group of ladies said, “Mr. Mackenzie will know; ask him.” And Mackenzie, returning to the light, was the attentive host again. Waddy, meanwhile, crossed the grass quickly to the honeysuckle path.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was the last to take leave; when Mackenzie returned, after escorting Mrs. North and Mrs. Tracy to the Villa Dorio, he was still in the garden with Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Fifteen minutes later, through the open windows of Mrs. North’s chamber there came the sound of steps.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Waddy,” said Charlotte Tracy, peeping through the closed blinds, and recognizing his figure. “He has outstayed everybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You are no longer afraid of him, I trust?” inquired Mrs. North.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Certainly not,” said the older lady with decision. After a moment she added, “She must always amuse herself, I suppose.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She has the very best of safeguards.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now there you go, with your cold-blooded judgments, Laura! Dorothy has as deep feelings as anybody. I don’t know where you get your knowledge of her; you are her step-mother, it is true; but I have been with her as constantly as you have for years.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Quite so. May I ask how well you knew her father?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t care!” was Charlotte’s reply. She left the room with majesty. The majesty lasted through the hall, and into her own chamber, as she reflected, “I have feelings. And Dorothy has feelings. But Laura is a stone!” At this moment she caught a glimpse of herself in the full-length mirror, and majesty collapsed. “Do I look like that? Do I? Stout, short-nosed?” And she sank down on a sofa overwhelmed. But presently a laugh broke through her discomfiture. “The very next crumpled little old man I see, I’ll be nice to him! I’ll ask who is his favorite poet, and I’ll get him to quote—yes, even if it’s Byron!” Mrs. Tracy’s favorite author was Ibsen.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You will do it if I wish, won’t you, Alan?” said Dorothy the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why, if you really wish it—if you think it best—” began Mackenzie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She doesn’t in the least,” interposed Mrs. North. “Don’t indulge her so; you will spoil her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mackenzie’s eyes turned towards his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t look at me to see whether mamma is right,” said Dorothy, laughing; “invent an opinion of your own about me—do! But let us have something striking; consider me capable of murder, for instance, not of mere commonplace selfishness. Every woman is capable of murder once; I am perfectly sure of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My dear,” said Mackenzie, expostulatingly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know whether I could quite do it with my own hands,” Dorothy went on, stretching out her palms and looking at them. “But Felicia Philipps could; yes, with her long fingers. Brrrr!” And she rushed to her husband and hid her face on his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She had her way, which was not a murder, but a ball. Soon afterwards there was a summer-night party at Belmonte, with music and dancing; the tower and the garden, illuminated, were visible for miles roundabout, like a fairy-land on the dark hill. Then followed excursions, long drives, and, more frequently, long rides; for Dorothy had taken to riding. Mackenzie accompanied the riding-parties cheerfully. But Dorothy was often far in advance with one of the younger cavaliers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I believe I should come back from the dead, Alan, to see you pounding along, always at the very end of the procession, with Miss Jane Wood,” said the young wife one day. “I know you don’t care much about riding. But why do you always escort Miss Jane? She must weigh one hundred and eighty.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She is a little timid, I think,” answered Mackenzie; “at least, I have fancied so. She only goes to see to Miss Hatherbury.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As you see to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mackenzie liked long walks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But walking is so dull. And the people who take long walks have such an insufferable air of superiority,” commented Dorothy. “Not that you have come to that, Alan; with you it’s just simple vanity.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And making the motion of turning up trousers at the bottom, she crossed the garden, holding her riding-whip like a cane, with her shoulders put back, her head run out a little, and a long step with a dip in the middle of it—the whole an amusing caricature of her husband’s gait when starting on a long excursion. Mackenzie had taught himself that gait; he had even been a little proud of it. But now he joined irrepressibly in his wife’s merriment, as she loped down the broad walk, and then came running back to him with her own light swiftness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Occasionally, however, she went with him for a stroll. One day late in the afternoon they passed Villa Dorio together. The sun, low in the west, was shining on all the square Tuscan towers that dot the hill-tops in every direction. May was now more than half spent, and the air was like that of July in Northern countries. The ladies of Villa Dorio saw them go by; Dorothy’s straw hat was hanging by its ribbons from her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He hates to have her out without her hat,” remarked Mrs. Tracy, leaning forward to watch them for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, in that dress, she doesn’t look more than fourteen,” answered Mrs. North.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mr. and Mrs. Mackenzie went on down the hill. When they came to the first zigzag, they left the main road, and, turning, crossed a grassy little piazza; beyond, clinging to the side of the hill, with a cluster of cypresses before it like tall green candles, is the small church of San Vito, commanding a magnificent sweep of the valley below. As they passed, San Vito’s chimes rang the Angelus, swinging far out from the open belfry against the sky with all the abandon of Italian bells, which seem forever joyous—almost intoxicated—even for the dead. San Vito’s has a path of its own which follows a narrow shelf overhanging the valley; the two pedestrians turned down this path. As the bells ceased, Dorothy began to sing:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ring out across the sunset sky, Angelus—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Go on; go on,” said Mackenzie, delightedly. “Oh, I can’t sing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Dear, I think you could; your voice is so sweet. If you would take lessons—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, by-and-by. We have lots of time for everything, Alan.” When they came to the turn where there is a rustic shrine she paused. “I won’t go any farther, I think. But don’t stop because I do; you like your walk. Go on, and come back through the olive groves just beyond Belmonte; I will be waiting for you at our wall.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t like to leave you here alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not under the shrine? What’s more, here is the priest.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The priest of San Vito’s was coming down the path. He was an old man, with a large, sensible face, and a somewhat portly person dressed in well-brushed black. He aided his steps with a cane. His bearing was serene and dignified. As he passed, Mackenzie saluted him, raising his hat.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“For a Unitarian,” said Dorothy, after the worthy man had gone by, “aren’t you showing a good deal of courtesy? But you would be courteous to any religion; you would respect the fetish of a South Sea Islander. Do you know, Alan, that you have too many respects? Please go now, so that you can be back the sooner.” Mackenzie, who had been leaning against the parapet, turned and began to go down the descent. His wife followed him for a step or two, in order to brush some mortar from his sleeve. “You see it is I that must keep you respectable—in spite of your respects.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("How pretty she was! They were alone under the high wall. “My darling,” he murmured. And Dorothy, laughing, raised herself on tiptoe to kiss him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Half an hour later, when he reached the wall near Belmonte, there was no Dorothy. He went within. The signora had gone to Villa Dorio, the servant said. He came out and followed her thither. Yes, Dorothy had been there; but Waddy Brunetti had happened in, and they had strolled down as far as San Vito’s.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mackenzie did not say, “But she has just been to San Vito’s.” He sat talking with the ladies for twenty minutes or more; then he remarked, offering it as a suggestion for their approval, “I think I will walk on to San Vito’s and meet them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, do,” said Mrs. North. “And make that foolish Dorothy put on her hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It is as warm as midsummer. And the air is perfectly dry, I think; no dew,” Mackenzie answered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He defends her even when she vexes him,” commented Charlotte Tracy, after he had gone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He might as well be amiable, seeing that he cannot be interesting,” Mrs. North responded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy was not at San Vito’s. And she had not gone down the zigzags of the carriage-road; he went down to see. He returned to Belmonte. It was now late twilight. But there was still a band of orange light in the west, and, outlined against it, on the top of the tower, were two figures. He recognized them instantly—Dorothy and young Brunetti.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy waved her hand to him through one of the embrasures. “Send up some one with candles,” she called.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“With what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Candles; it’s too dark now to come down without lights. But don’t send immediately; wait fifteen minutes more, so that we can see the moon rise. And, Alan!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Please tell them that Mr. Brunetti will stay and dine with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("IV")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On the 29"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("th")]), _vm._v(" of December of this same year, 1882, Reginald Illingsworth was paying a visit to Mrs. Sebright.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What a career that little girl will have!” he said, with deep gustatory appreciation.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Before this, for half an hour, he had been making remarks of a nature best described by the following examples: “That excellent fellow, Mackenzie! You can’t think how I miss him!” “There is something so tragic in such a death—a man who had everything to live for!” “How could they go to Rome! That pernicious Roman fever is the curse of Italy.” “Those poor ladies! Directly I heard they had returned to Belmonte, I went up at once to inquire and to leave cards; it is a stricken house!” Having said everything that decorum required, he now finally allowed himself to bring out the thought which was in reality filling his mind: “What a career that little girl will have! Only nineteen, and so very pretty, so charming. He has left her everything without a condition (save in the event—most improbable at her age—of her dying without children, in which case it goes back to his own relatives), and I am told that he had nearly eight millions of dollars; that is, one million six hundred thousand pounds! They are shrewd in their American way—those ladies; Mrs. North is very shrewd. And mark my words, madam, that little girl will make one of the great matches yet; not pinchbeck; something really good!” (His “good” had a deeply solid sound.)")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This same afternoon the following words were exchanged in another quarter of Florence:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rose, dear,” said Miss Jane Wood, “you will go up again to-morrow, won’t you, to see poor Dorothy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have been twice—all that is necessary for appearances, Aunt Jane. Why should I bother Dorothy now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sympathy—” began Miss Jane.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sympathy! She is in a position to extend it to me. I think she is the very luckiest girl I have ever heard of in my life. All another girl can do in the face of such luck as that is to keep away from it, and not think about it—if she can.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Miss Jane Wood: “I am astonished!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Miss Maria: “!!!!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That evening, at Belmonte, Dorothy walked and walked about the drawing-room; now she stopped at a table, took up something and put it down again; now she moved a statuette to another position; now she gazed at the etchings on the wall as though she had never seen them before; now she added pine-cones to the already blazing fire, kneeling on the rug with the hot flame scorching her face; finally she went to the window, and, parting the curtains, stood looking out. It was a dark night without stars; in addition to the freezing temperature, the wind was fierce; it drove furiously against the windows of the villa, it came round the corner of the tower with a shriek like that of a banshee.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s dreadfully cold,” said the girl at last, as if speaking to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Surely not here?” replied Mrs. Tracy. Dorothy came wandering back to the fire, and then the aunt drew her down by her side. “Dear child, don’t keep thinking of Rome,” she whispered. “He is not there; there is nothing there but the lifeless clay.” And she kissed her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Try not to be so restless, Dorothy,” said Mrs. North, from her warm corner. “You have walked about this room all day.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s because I’m so tired; I am so tired that I cannot keep still,” Dorothy answered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I think a change would be a good thing for all of us,” Mrs. North went on. “We could go to Cannes for two months; we could be as quiet at Cannes as here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy looked at her with vague eyes, as if waiting to hear more.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It is warmer there. And then there is the sea—to look at, you know,” pursued Mrs. North, seeing that she was called upon to exhibit attractions.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Egypt would be my idea,” said Mrs. Tracy. “A dahabeeyah on the Nile, Dorothy. Camels; temples.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy listened, as if rather struck by this idea also.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But Egypt would be a fearful trouble, Charlotte,” objected Mrs. North. “Who is going to get a good dahabeeyah for us at this time of year?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t spoil it. I’ll get twenty,” responded the other lady.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And then there was a silence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, Dorothy, are you going to leave it to us to decide?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, mamma,” Dorothy answered. Her eyes had grown dull again; she sat listening to the wind as if she had forgotten what they were talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s decided, then. We will go to Cannes,” remarked Mrs. North, serenely.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her Aunt Charlotte’s discomfited face drew a sudden laugh from the niece. And this laughter, once begun, did not cease; peal succeeded peal, and Dorothy threw herself back on the cushions of the sofa, overcome with merriment. Mrs. North glanced towards the doors to see if they were well closed. But Charlotte Tracy was so glad to hear the sound again that she did not care about comments from the servants; Dorothy’s face, dull and tired, above the dead black of the widow’s attire, had been like a nightmare to her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They went to Cannes. And Mrs. North’s suggested “two months” had now lengthened, in her plans, to three. But before two weeks, had passed they were again at Belmonte.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now that we have made one fiasco, Charlotte, and taken that horrible journey, all tunnels, twice within twenty days, we must not make another; we must decide to remain where we are for the present. If Dorothy grows restless again, be firm. Be firm, as I shall be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Surely we ought to be indulgent to her now, Laura?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not too much so. Otherwise we shall be laying up endless bother for ourselves. For we have a year of hourly employment before us, day by day. In the way of seeing to her, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She will not make us the least trouble,” said Mrs. Tracy, indignantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am not finding fault with her. But she cannot help her age, can she? She is exceedingly young to be a widow, and she has a large fortune; but for a year, at any rate, if I know myself, gossip shall not touch my daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A year? I’ll guarantee ten,” said Mrs. Tracy, still indignant.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t care about ten; three will do. Yes, I see you looking at me with outraged eyes. But there’s no need. I liked Alan as much as you did; I appreciated every one of his good points. With all that, you cannot pretend to say that you believe Dorothy really loved him. She was too young to love anybody. The love was on his side, and you were as much surprised as I was when she took a fancy to accept it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy could not deny this. But she belonged to that large class of women who, from benevolent motives, never acknowledge unwelcome facts. “I think you are perfectly horrid!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy, back at Belmonte, was troublesome only in the sense of being always in motion. Having exhausted the garden, she began to explore the country. She went to Galileo’s tower; to the lonely little church of Santa Margherita; the valley of the Ema knew her slender black figure. Once she crossed the Greve, and, following the old Etruscan road, climbed to the top of the height beyond, where stands the long, blank Shameless Villa outlined against the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you know, I am afraid I am lame,” said Mrs. Tracy, the morning after this long tramp to the Shameless.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, why do you go? One of us is enough,” answered Mrs. North.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To the walks Dorothy now added lessons in German and Italian. Mrs. North drove down to Florence and engaged Fräulein Bernstein and Mademoiselle Scarletti. Next, Dorothy said that she wished to take lessons in music.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A good idea. You ought to play much better than you do,” said her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Piano; but singing too, please,” Dorothy answered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Again Mrs. North descended to Florence; Fräulein Lundborg was engaged for instrumental music, and Madame Farinelli for vocal. Dorothy wished to have a lesson each day from each of her teachers. “It’s a perfect procession up and down this hill!” thought Mrs. Tracy. There was a piano in the billiard-room, and another in the drawing-room; but now Dorothy wished to have a third piano in her own sitting-room up-stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But, my dear, what an odd fancy! Are you going to sing there by yourself?” her mother inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes!” said Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you think she is well?” asked Mrs. Tracy, confidentially, with some anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Perfectly well. It is the repressed life she is leading,” Mrs. North answered. “But we must make the best of it. This is as good a place as any for the next three months.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But again this skilful directress was forced to abandon the “good place.” Early in March, when the almond-trees were in bloom, Dorothy, coming in from the garden, announced, “I hate Belmonte! Let us go away, mamma—anywhere. Let us start to-morrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We took you to Cannes, and you did not wish to stay. We shall be leaving Belmonte in any case in June; that isn’t long to wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You like Paris; will you go to Paris?” the girl went on.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What can you do in Paris more than you do here?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I love the streets, they are so bright—so many people. Oh, mamma, if you could only know how dull I am!” And sinking down on the rug, Dorothy laid her face on the sofa-cushion at her mother’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy coming in and finding her thus, bent and felt her pulse.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, one hundred and fifty!” said Dorothy, laughing. “Take me to Paris, and to the opera or theatre every night, and it will go down.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, you don’t mean that,” said the aunt, assuringly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, but I do,” Dorothy answered. And then, with her cheek still resting on the cushion, she looked up at her mother. “You will take me, mamma, won’t you? If I tell you that I must?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes,” replies Mrs. North, coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They went to Paris. And then, for four weeks, almost every night at the back of a box at the opera or at one of the theatres were three ladies in mourning attire, the youngest of the three in widow’s weeds. Mrs. Tracy was so perturbed during these weeks that her face was constantly red.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why are you so worried?” Mrs. North inquired. “I manage it perfectly; people don’t in the least know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do I care for ‘people’? It’s—it’s—” But she would not say “It’s Dorothy.” “It’s ourselves,” she finally ended.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Always sentimental,” said Laura.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Midway in the first week of April, Dorothy suddenly changed again. “I can’t stay here a moment longer!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Perhaps you would like to take a trip round the world?” suggested Mrs. North, with a touch of sarcasm.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. I don’t know what you will say, mamma, but I should like to go back to Belmonte.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have a good deal of patience, my dear, but I must say that you wear it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know I do; but if you will take me back, I promise to stay there this time as long as you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I like—” began Mrs. North; but Dorothy, with a frown, had rushed out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What shall we do now?” said the aunt.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Go back, I suppose; I have always thought Belmonte the best place up to really hot weather. One good thing: if we do go back we can take the opportunity to rid ourselves definitely of both of those villas. My idea is the Black Forest country for August and September. Then we could come here again for a few weeks. For the winter, what do you say to a long cruise towards the South somewhere, in a yacht of our own? We could select the right people to go with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They returned to Italy, reaching Bellosguardo again on the 11th of April.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On the 6th of May Charlotte Tracy said, “Laura, to me this is dreadful! Waddy is here morning, noon, and night.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So many people have left Florence that it hardly matters; nobody knows what is going on up here. He amuses her, and that is something gained.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I wish he wouldn’t be forever singing!” said the aunt, irritably.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He sings very well. And Dorothy has shown a new interest in singing lately. Don’t you remember that she took lessons herself before we went to Paris?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You don’t mean to intimate that Waddy had anything to do with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why not? A girl of that age has all sorts of changing interests and tastes; there will be something new every month or two, probably, for a long time yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In June, Mrs. Tracy demanded, “Is Owen Charrington one of your something-news?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I dare say he is,” Mrs. North answered, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For Owen Charrington had come back from Australia. He found the zigzags which led to Belmonte very hot and very solitary; there was no Waddy going up or coming down, either on foot or in a carriage, although his ascents and descents had been as regular as those of the postman during the six preceding weeks. Shortly before Charrington’s return, Dorothy, entering the boudoir one evening at ten o’clock, said:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mamma—Aunt Charlotte—will you tell the servants, please, that whenever Mr. Brunetti calls, after this, they are to say that we are engaged, or not at home? I don’t suppose you care to see him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What can have happened?” said Mrs. Tracy, when the girl had gone out again without explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There hasn’t been time for much to happen. I have been out there with them all the evening; I only came in for my tea,” answered Mrs. North, sipping that beverage.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Since then he has been singing. At least, I thought I heard his voice—not very loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Perhaps she is tired of his voice—not very loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy threw a lace scarf over her head and went out to the garden. The long aisles under the trees were flooded with moonlight, the air was perfumed with the fragrance of the many flowers; but there was no Dorothy. She entered the house by another door, and, going softly up the great stairway, turned towards Dorothy’s rooms at the south end of the long villa. Here a light was visible, coming under the door of the sitting-room; the aunt did not lift the latch, she stood outside listening. Yes, Dorothy was there, and she was singing to herself in a low tone, playing the accompaniment with the soft pedal down:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Through the long days, the long days and the years,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What will my loved one be,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Parted from me, parted from me,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Through the long days and years?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She is up there singing; singing all alone,” reported the aunt, when she is came back to the boudoir down-stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I suppose you like that better than not alone?” suggested Mrs. North.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Waddy came to Belmonte five times without success. Then he left Florence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy did not stroll in the garden with Owen Charrington. If her mother and aunt were outside when he came, she remained with them there; but if they were in the drawing-room or the boudoir, she immediately led her guest within; then she sat looking at him while he talked. Charrington talked well; all he said was amusing. Dorothy listened and laughed. If he paused, she urged him on again. This urgency of hers became so apparent that at last it embarrassed him. To carry it off he attacked her:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You force me to chatter, Mrs. Mackenzie—to chatter like a parrot!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes,” answered Dorothy, “you must talk; you must talk all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“‘All the time’—awfully funny Americanism!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And the French ‘tout le temps’?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, French; I don’t know about French.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Of course you don’t. We are willing to be funny with the French. Are you ‘very pleased’ to be here to-day? Answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Of course I am very pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And you would say, wouldn’t you, ‘Directly I returned to Florence, I bought a horse’?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But I didn’t,” said Charrington, laughing; “I only hired one. And that reminds me, Mrs. Mackenzie; you can’t think how divine it is now at four o’clock in the morning. Won’t you go for a ride at that hour some day soon? Mrs. North and Mrs. Tracy could follow in the carriage” (with a look towards those ladies).")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ride?” repeated Dorothy. A flush rose in her cheeks. “No,” she answered, in an altered voice—”no!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She said nothing more, and she did not speak again; she sat looking at the floor. Mrs. North filled the pause with her placid sentences. But Dorothy’s manner was so changed and constrained that the young Englishman soon went away. The girl had taken something into her head. But it would not last long; nothing ever did last long with Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This belief of his was soon jostled by the fact that Dorothy would not see him. Mrs. North covered the refusal as well as she could by saying that her daughter was not well; that she was not seeing any visitors at present. But Florence was empty; there were no visitors to come; it simply meant, therefore, that she was not seeing Owen Charrington. He lingered on through the month, coming every day to Belmonte. Mrs. North received him graciously. But he was obliged to content himself with a close investigation of their plans for the summer. At last, on the 2d of July, unable any longer to endure the burning, glaring Lung’ Arno and the furnace-like atmosphere of the Hôtel d’Italie, he took his departure. He went to Baden-Baden, writing home to his family that he should probably spend the summer in the Black Forest country with friends.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The morning after Charrington’s departure, illness (real illness this time) seized Dorothy. For a week she remained motionless on a couch, her face white, her eyes closed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We must take her to Switzerland; we must go straight up to the snow,” said Charlotte Tracy. “When she sees the glacier water she will revive at once. The gray glacier water, you know; one begins to meet it at Chiomonte; it comes rushing over the rocks, gray and cool, with sometimes a little foam; but gray, always gray—a sort of leady gray.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She said gray so many times that Mrs. North cried out at last, “Oh, do call it green!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Speedy preparations were made for departure; the trunks were packed and sent down to the railway station. Dorothy remained passive, making no objection to their plans, but showing no interest in them. Caroline, her maid, dressed her for the journey. But when the little black bonnet with its long black veil had been put on, and the black gloves, and the young mistress of the house rose to walk to the carriage, after a few steps her figure swayed, and she sank to the floor; she had fainted. She remained unconscious for so long a time that it was evident there could be no travelling that day; they must wait until she was stronger. They waited, therefore, from one day to the next, each morning expecting to start, and each morning postponing departure. The 15"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("th")]), _vm._v(" of July found them still at Belmonte. The thick stone walls of the majestic old house kept out the burning sunshine, and Dorothy appeared to like the warm air that came in through the shaded windows; she lay breathing it quietly, with her eyes closed. The American physician of Florence had gone to New York for six months. An English doctor came up daily. But there was nothing to combat. There was no fever, no malady save this sudden physical weakness. Everything possible was done for this, but with small results. At last Dr. Hotham advised them to attempt the journey in any case. A nurse was engaged; Dorothy was to be carried on a couch to the station, where a railway carriage, provided with an invalid’s bed, was waiting. But before they had traversed a quarter of the length of the Via dei Serragli, the clatter of the carriage wheels and the other noises of the street threw the girl into a delirium, and they returned hastily to Bellosguardo. The delirium passed away and they made another attempt. This time they were to cross Florence in the middle of the night, and a special train was to take them northward. But the paroxysm came on again, and with greater violence. Before they reached the bottom of the Bellosguardo hill Dorothy threw up her arms like a wild creature; the nurse could scarcely hold her. This time high fever followed; the girl, now in bed, lay with scarlet cheeks and glassy eyes, knowing nobody. Dr. Hotham conquered the fever. Then she was as she had been before, save that the weakness was increased.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With the exception of Dr. Hotham, there was now no one in Florence whom they knew. Nora Sebright remained at St. Martin’s Orphan House out in the country; but she knew nothing of events in town. One day Dr. Hotham, having been called to the orphan house to see a child, spoke to Nora of the puzzling illness of Mrs. Mackenzie; he knew that the Sebrights were among the acquaintances of these American ladies. Nora hurried to town, and, although it was evening, drove up to Belmonte without delay. There were now two nurses at the villa. But Nora was the best nurse; and, after seeing Dorothy for a moment, she begged the mother and aunt to allow her to remain and assist.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You are extremely kind, Miss Sebright. But I do not think you ought to give yourself so much trouble,” said Mrs. North. “Dorothy will soon be stronger; the fever, as you see, has entirely disappeared, and in a few days we shall go to Switzerland.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Nora followed Mrs. Tracy into the next room. “Dear Mrs. Tracy, do let me stay. I am such a good nurse—you can’t think. And I am so fond of Dorothy. And I really think she ought to be amused, if possible. Not that I am very amusing; but at least it makes one more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was no lamp in this room, but, all the same, Charlotte Tracy seemed to read an expression in the face she could not see. “What has Dr. Hotham said to you?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Indeed, nothing; he never talks. It is only that Dorothy has always been so well; she was well all winter, you know. Even now (for the fever was only the effort of the journey) there seems to be nothing one can take hold of. And so the question came up, as it always does in such a case, could she have anything weighing upon her mind—weighing too much, I mean? But I am sure,” continued Nora, her voice calm as usual (but her face, in the darkness, quivering for an instant), “that we need apprehend no danger of that sort; Dorothy’s mind is perfectly healthy. And she has been from the very first so brave, you know—so wonderfully brave.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Charlotte Tracy, a prey to conflicting feelings, bent and kissed Nora without a word. Grief for Alan Mackenzie had indeed been more deeply felt at the dreary orphan house down in the dusty valley than in his own home on this beautiful hill. Nora stayed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("August burned itself out. At Belmonte the heavy outer portals were kept closed; within, all the doors stood open in order to create, if possible, a current of air through the darkened rooms. Once in two hours, night and day, Nora came to Dorothy’s bedside and offered some delicate nourishment; Dorothy took it unobjectingly. She seldom spoke, but she appeared to like Nora’s presence and her gentle ministrations.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy had forced herself to speak to Laura about the doctor’s question. Some force was necessary, for she was always exasperated by Laura’s replies. “I am beginning to be a little frightened about Dorothy, Laura; she doesn’t gain. It is no time to mince matters; such things have happened before, and will happen again as long as the world lasts, and it seems that even Dr. Hotham has asked whether there could be anything weighing upon her mind. Now what I want to know is, do you think she is brooding about something?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Brooding?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes. I mean, do you think she is interested in somebody?—Owen Charrington, if I must name him. You used to think that she liked him? And that she cannot bear the separation? Yet thinks it too soon? And that that was the reason she refused to see him again? And now it is weighing upon her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mercy, what theories! You have always saddled Dorothy with deeper feelings than she has ever possessed. Do leave the poor child alone; don’t make her out so unusual and unpleasant; she is like any other girl of nineteen. She is interested in Owen—yes; but not in that exaggerated way; she isn’t pining herself ill about him. And let me tell you, too, that if he were to her at this moment all you are imagining him to be, she wouldn’t in the least be deterred by considerations of its being ‘too soon,’ as you call it; she would not even remember that it was soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy’s eyes filled.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, what now? Do you wish her to be breaking her heart for Alan? I thought you came in to suggest sending post-haste for Owen Charrington! Do you know really what you want yourself? Dorothy will grow stronger in time. A hot summer in Italy has pulled her down, but with the first cool weather she will revive, and then we can carry out our plans.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Towards the middle of September the rains came, the great heat ended. With the return of the fresh breeze Dorothy left her bed, and lay on the broad divan among its large, cool cushions; she even walked about the room a little, once or twice a day. The first time she walked they saw how thin she was; the black dressing-gown hung about her like a pall.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Take it off,” said Mrs. Tracy, when she had beckoned Caroline into the next room. “Never let her wear it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But I have fear that madame is not enough strong yet to wear a costume,” suggested the maid, respectfully.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy unlocked a wardrobe and took out a pile of folded draperies. They were white morning dresses, long and loose, covered with beautiful laces and knots of ribbon; they had formed part of Dorothy’s trousseau. “Let her wear these,” she said, briefly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy made no objection to the change. Occasionally she looked at her new attire, and smoothed out the ribbons and lace. Throughout her illness she had scarcely spoken. They had supposed that this silence came from her weakness—the weakness which had made it an effort sometimes for her to lift her hand. But now that she was up again, and walking about the room, the muteness continued. She answered their questions, but it seemed necessary for her to recall her thoughts from some distant place in order to answer. She lived in a reverie, and her eyes had a far-off expression. But these were slight things. When ten days had slowly passed without any relapse, Charlotte Tracy, who had counted the hours, exclaimed, with joy, “Now we can go!” Dr. Hotham was to accompany them as far as Vevey. Nothing was to be said to Dorothy, in order that she should not have even a feather’s weight of excitement; but the preparations were swiftly made. On the afternoon before the day appointed for the start, Dorothy suddenly left her easy-chair, crossed the room, opened a door, and looked down a corridor. At the end of the corridor she saw Caroline kneeling before open trunks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What are you doing, Caroline? Those are my trunks, aren’t they? You may stop; I shall not leave Belmonte.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nora, who had followed, led her back. “Your mother and aunt are so very anxious to go north, dear,” she explained. “Come and lie down; you must not tire yourself before the journey.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Dorothy resisted. “Please call them, Nora; call them both; I must tell them. I know mamma; she will have me carried. But that is because she does not understand. When I tell her, it will be different. Please call them both.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When they came in—Mrs. Tracy alarmed, Mrs. North smiling as if prepared to be, outwardly, very indulgent—Dorothy was still standing in the centre of the room, the laces of her white dress fluttering in the soft breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mamma,” she said, “I must tell you. Aunt Charlotte, you have always been kind to me. I cannot go away; do not ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sit down, Dorothy. Nora, make her sit down. You will not be asked to take a step, my daughter; everything is arranged; don’t trouble yourself even to think.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You do not understand, mamma. But I myself have not understood until lately. I cannot leave Belmonte.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But Dr. Hotham thinks you can,” interposed Mrs. Tracy, soothingly; “he knows how much strength you have. We are all going with you, and the journey will be very easy. You used to like Vevey.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let me stay here; I wish to stay here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But we have never intended to spend our lives at Bellosguardo,” answered Mrs. North, drawing her towards the divan and making her sit down.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let me stay a little while longer, mamma.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You mean that you will be willing to go later? But, we think that now is the time. You have nothing to do save to rest here quietly, and then go to sleep; you will open your eyes in Vevey.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy, seated, her hands extended on her knees, looked up at her mother. “Mamma, you don’t know. There’s an ache that will not leave me. I haven’t told you about it. But I’m so unhappy!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Tracy, hurrying forward, put her arm round the girl protectingly. Mrs. North, her face slightly flushed, whispered to Nora:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She is wandering. Please go and send some one immediately for the doctor. Write a note for the man to take with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In this way she got rid of Nora.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy, alone with her mother and aunt, went on talking: “I didn’t know what it meant myself for ever so long. But now I do, and it’s all simple. I shall just stay quietly here. This is the best place. And you mustn’t mind, for it makes me very happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My darling, have you written? What do you mean?” asked Mrs. Tracy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What do I mean?” Dorothy repeated. She smiled; into her white face came a flush of color. “I mean that I shall see him very soon now. It won’t be long to wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She has sent for him,” thought the aunt. “I was right; it is Owen.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That is why I wish to stay here,” Dorothy went on. “Everything here is associated with Alan; he liked Belmonte so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Alan?” breathed the aunt, amazed, but instantly concealing her amazement. Mrs. North quickly measured some drops from a phial containing a sedative.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dorothy let her head sink back against the cushions. ”In the beginning I didn’t in the least know that I was going to feel it so. But that ache came, and it wouldn’t stop. I tried all sorts of things—don’t you remember? I tried studying. I tried music lessons. He used to urge me to sing. He liked long walks, and I never would go; so then I took long walks. You haven’t forgotten them, have you? But the ache went on, and I could not stand it. So I asked you to go to Paris. Paris has always been so funny and amusing. But it wasn’t funny any more. When we came back here I thought that perhaps some one coming up every day and staying a long time would make me forget. But having Waddy was worse than being alone, and at last I hated him. Owen Charrington, too! Owen used to make me laugh; I thought he would make me laugh again. But he didn’t at all. And when he asked me that last day to ride it was like a knife; for Alan always went with me, and would never say anything to spoil my pleasure. Yet he did not care about it really, though I insisted upon going day after day. That is the way it was about everything. But I’m paying for it now; I miss him so—I miss him so! Alan! Alan!—” And putting her thin hands over her face, Dorothy burst into miserable heart-broken sobs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nora came running in; Mrs. North handed her the medicine glass.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hysterics,” she said. “Give her those drops as soon as you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I look to you, doctor, to get us out of this new difficulty,” said this lady the next day to Dr. Hotham. “She has taken this fixed idea that she does not wish to leave Belmonte. But the fixed idea of a girl of nineteen ought not to be a trouble to you. Can’t you suggest something? Has science no resources for such a case?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "src": "image/3.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“‘I MEAN THAT I SHALL SEE HIM VERY SOON NOW’”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dr. Hotham’s resource was to send to Rome for a colleague. The most distinguished English physician in Italy was called to Florence, and there was a consultation at Bellosguardo. When it was over Mrs. North came in to see the great man.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His sentences were agreeable; they were also encouraging. After a time he spoke of the varying forms of nervous prostration; then he asked whether this very interesting young lady could have, by any possibility, something weighing upon her mind?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, nothing,” replied the mother.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah! In that case time, I trust, is all that is necessary for a complete recovery.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My own idea would be to take her north in spite of her disinclination to go,” Mrs. North went on. “A disinclination ought not to be important. The journey would soon be over. She could be kept under the influence of sedatives. But Dr. Hotham will not give his consent.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I agree with him, madam. Do not force her; the effect upon the nervous system might be bad. Let her do whatever she fancies. Amuse her. What a pity there is no Corney Grain in Italy!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Everything in the way of amusement has been tried. That is why I wish to take her away.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah! I understood you to say, I think, that there is no hidden cause, no wish, no mental—ah—err—strain?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nothing of any consequence. She is hysterical sometimes; but that is owing to her physical weakness,” Mrs. North answered. And she said what she believed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A month later Dorothy, lying on a couch in her room, put out her hand to Nora. “I must give you some of my money, Nora, for your poor people—your orphans and the school and the hospital. I will give it to you to-morrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You can help Nora to distribute it,” said Mrs. Tracy.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Dear Aunt Charlotte, how you hate to hear me speak of it! But I talk to Nora, you know, just as I please in the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No; talk to me, too. Say whatever you like,” answered Mrs. Tracy, quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "src": "image/4.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Caption--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("BELMONTE")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It is so warm this evening that I can have all the windows open,” Dorothy went on. “Take the lamp out, Nora, please, and let in the moonlight; I like to see it shining across the floor.” She lay in silence for some minutes looking at the radiance. They had cut off her hair, thinking that its length and thickness might be taking something from her small store of strength. Her face, with the boyish locks, looked very childlike. “Do you remember that song, Aunt Charlotte, ‘Through the long days’? The moonlight makes me think of it. First, Felicia Philipps sang it one moonlight evening over at Villa Dorio. Then, after we were married, some one sang it here in the garden, and Alan said, when it was over—Oh, if I could only tell him once, just once, that I did love him! He never believed it—he never knew—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t cry, dear. Don’t.”q")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No; I don’t cry very often now,” Dorothy answered, her breast rising in one or two long sobs. “Last spring Waddy dared to sing that song again—Alan’s song! I could not see him after that.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Through the long days, the long days and the years—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It will tire you to sing, dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No; I like it.” And then, in a faint little thread of a voice, barely audible, but very sweet, she sang, lying there in the moonlight, the beautiful song:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Through the long days, the long days and the years,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What will my loved one be,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Parted from me, parted from me,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Through the long days and years?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Never, ah, never on earth again—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was her last song. Three days later she died. She passed away so quietly that they did not know it was death, they thought she was asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When at last they learned what it was, Mrs. North, standing beside the couch, white and stern, said, with rigid lips, “The doctors did not tell us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But the doctors did not know.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ec8148","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled16.vue
// module id = 66
// module chunks = 0